import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenDashboardService, DashboardStatusBreakdownItem } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

type StatusBreakdownType = 'candidate' | 'carePartner'

export const useStatusBreakdown = (type: StatusBreakdownType) => {
    const [items, setItems] = useState<DashboardStatusBreakdownItem[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchStatusBreakdown = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<DashboardStatusBreakdownItem[]> = AspenDashboardService.getStatusBreakdownDashboardStatusBreakdownGet({
                type
            })
            const data = await response
            setItems(data)
        } catch (err) {
            setError('Failed to fetch status breakdown')
            enqueueSnackbar('Failed to fetch status breakdown', {
                variant: 'error'
            })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar, type])

    useEffect(() => {
        fetchStatusBreakdown()
    }, [fetchStatusBreakdown])

    return { items, loading, error, fetchStatusBreakdown }
}
